import { render, staticRenderFns } from "./especialidade.vue?vue&type=template&id=15e50c80&"
import script from "./especialidade.vue?vue&type=script&lang=js&"
export * from "./especialidade.vue?vue&type=script&lang=js&"
import style0 from "./especialidade.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports